// extracted by mini-css-extract-plugin
export var share = "ShareBlock-module--share--d5fbb";
export var shareBlock = "ShareBlock-module--shareBlock--a92a5";